import { render, staticRenderFns } from "./pingzheng.vue?vue&type=template&id=1bacc688&scoped=true&"
import script from "./pingzheng.vue?vue&type=script&lang=js&"
export * from "./pingzheng.vue?vue&type=script&lang=js&"
import style0 from "./pingzheng.vue?vue&type=style&index=0&id=1bacc688&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacc688",
  null
  
)

export default component.exports